export default {
  view: {
    back: {
      title1: 'Wait, registration process in progress...',
      title2: 'You will receive a confirmation by SMS',
      buttonTopup: 'Register again',
      buttonBack: 'Next',
      loading: 'Wait. Verification of payments is underway...'
    }
  },
  component: {
    cookie: {
      text: 'I consent to the storage of cookies on my device.',
      button: 'OK'
    },
    header: {
      title: '<span class="no-wrap">Registering a SIM Plus card</span>'
    },
    progress: {
      step1: 'Starter data',
      step2: 'Verification',
      step3: 'Registration'
    },
    register: {
      loadingText: 'Downloading data...',
      labelPhone: 'Phone number',
      labelEmail: 'SIM card number',
      buttonNext: 'Next',
      title: '<strong>Step 1</strong> - Phone number and SIM card number',
      placeholderEmail: 'give your SIM card number',
      rodoText: 'The data administrator is Polkomtel sp. z o. o., ul. Konstruktorska 4 in Warsaw. The data will be processed for the purpose of registering a SIM card, pursuant to Art. 6 section 1 letter c GDPR in connection with Art. 60b of the Telecommunications Law and in order to conclude a contract for the provision of telecommunications services, pursuant to Art. 6 section 1 letter b GDPR. Due to the selection of the data verification model, the basis for data processing is the consent of Autopay S.A. to obtain from ING bank, data regarding my identity and transfer of this data to Polkomtel sp. z .o. o. to register a SIM card as a telecommunications service provider. Personal data may be transferred to the following categories of recipients: entities providing the administrator with services necessary to achieve the above-mentioned purposes, including IT partners, entities providing technical support or customer service. You have the right to: withdraw consent at any time (which does not affect the lawfulness of processing that took place before its withdrawal), rectification of data, access to data, deletion, limitation of processing, transfer. These requests can be submitted to the above-mentioned address of Polkomtel sp. z o. o., as well as: by phone to the Customer Service Department (tel. 601102601), by e-mail to bok@plus.pl, in writing or orally at the Sales (Service) Point or to the designated Data Protection Inspector at the following address: <a href="mailto:iod@plus.pl">iod@plus.pl</a>, possible complaints to the President of the Personal Data Protection Office. Detailed information on data processing and contact details of Polkomtel sp. z o.o. and the Data Protection Inspector appointed by him are available at <a href="http://www.plus.pl/dane-osobowe" target="_blank">www.plus.pl/dane-osobowe</a> (tab : "INFORMATION BY POLKOMTEL SP. Z O.O. ON THE PROCESSING OF CUSTOMER/CARD SUBSCRIBER\'S PERSONAL DATA").'
    },
    footer: {
      copyrights: '© {year} Polkomtel Sp. z o.o. All rights reserved'
    }
  },
  buttons: {
    logIn: 'Log in',
    register: 'Register'
  },
  validation: {
    invalid: 'Invalid field',
    required: 'Required field',
    operatorInvalid: 'Enter your Plus number',
    simInvalid: 'Enter a valid SIM card number',
    phoneInvalid: 'Invalid phone number',
    registered: 'This number is already registered',
    processError: 'An error occurred while processing data!'
  },
  globalMessages: {
    userSessionTimeOut: 'For security reasons, you have been automatically Logged out. Please login again.'
  }
}
